<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.profitReportTitle') }}</h4>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>
    <div class="panel-body" style="display: block">
      <div class="row mb-3 no-print">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime"
            :option="fromOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="endTime"
            :option="toOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4" style="display:flex; align-items:center; flex-wrap:nowrap; gap:8px;">
          <v-btn style="height: auto" @click="getData()" depressed :loading="loading">
            &nbsp; {{ $t('reports.apply') }}
          </v-btn>
          <v-btn v-if="loaded" class="no-print" @click="printReport()" color="blue-grey" dark small style="height:auto;">
            <v-icon left small>print</v-icon> {{ $t('reports.printReport') }}
          </v-btn>
          <p v-if="loaded" class="print-only"><strong>{{ $t('reports.periodColon') }} {{ startTime.time }} &mdash; {{ endTime.time }}</strong></p>
        </div>
      </div>

      <div class="row" v-if="loaded">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#3E8195" dark>
            <div style="font-size:13px;">{{ $t('reports.totalShipmentCardTitle') }}<span class="col-sub"><b>A</b> {{ $t('reports.equalsSigmaShipmentCost') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.total_shipment) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#3E8195" dark>
            <div style="font-size:13px;">{{ $t('profit.totalFee') }}<span class="col-sub"><b>B</b> {{ $t('reports.equalsSigmaShipzoneFeeCard') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.total_fee) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#3E8195" dark>
            <div style="font-size:13px;">{{ $t('reports.totalTaxCardTitle') }}<span class="col-sub"><b>C</b> {{ $t('reports.equalsSigmaTaxCollected') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.total_tax) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#3E8195" dark>
            <div style="font-size:13px;">{{ $t('reports.invoiceShipmentCardTitle') }}<span class="col-sub"><b>D</b> {{ $t('reports.equalsSigmaShipmentAmountInvoiced') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.total_invoice_shipment) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#b71c1c" dark>
            <div style="font-size:13px;">{{ $t('profit.totalRefund') }}<span class="col-sub"><b>E</b> {{ $t('reports.equalsSigmaRefundedAmountCard') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.total_refund) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#b71c1c" dark>
            <div style="font-size:13px;">{{ $t('reports.totalExpenses') }}<span class="col-sub"><b>F</b> {{ $t('reports.equalsSigmaBusinessExpenses') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.expense) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" color="#4caf50" dark>
            <div style="font-size:13px;">{{ $t('reports.netIncomeCardTitle') }}<span class="col-sub"><b>G</b> {{ $t('reports.equalsRevenueAfterRefundsFeesBeforeExpenses') }}</span></div>
            <div style="font-size:24px; font-weight:bold;">${{ fmt(result.income) }}</div>
          </v-card>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
          <v-card class="pa-3 mb-3 text-xs-center" :color="result.profit >= 0 ? '#2e7d32' : '#c62828'" dark>
            <div style="font-size:13px;">{{ $t('profit.title') }}<span class="col-sub"><b>H</b> = G &minus; F</span></div>
            <div style="font-size:28px; font-weight:bold;">${{ fmt(result.profit) }}</div>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import myDatepicker from 'vue-datepicker'

export default {
  components: { 'date-picker': myDatepicker },
  data() {
    return {
      loading: false,
      loaded: false,
      result: {},
      startTime: { time: '' },
      endTime: { time: '' },
      fromOption: this.$_datepickerOption(this.$t('columns.fromDate')),
      toOption: this.$_datepickerOption(this.$t('columns.toDate'))
    }
  },
  mounted() {
    this.initCurrentMonth()
  },
  methods: {
    initCurrentMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
      this.startTime.time = `${y}-${m}-01`
      this.endTime.time = `${y}-${m}-${String(lastDay).padStart(2, '0')}`
    },
    getData() {
      if (!this.startTime.time || !this.endTime.time) {
        swal(this.$t('common.error'), this.$t('reports.pleaseSelectFromToDate'), 'error')
        return
      }
      this.loading = true
      const token = localStorage.getItem('access_token')
      axios
        .get('api/profit', {
          params: { from_date: this.startTime.time, to_date: this.endTime.time },
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(res => {
          this.result = res.data
          this.loaded = true
        })
        .catch(() => swal(this.$t('common.error'), this.$t('reports.failedToLoadReport'), 'error'))
        .finally(() => { this.loading = false })
    },
    fmt(v) {
      return parseFloat(v || 0).toFixed(2)
    },
    printReport() { window.print() },
    $_datepickerOption(placeholder) {
      return {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        format: 'YYYY-MM-DD',
        placeholder,
        inputStyle: { display: 'inline-block', padding: '6px', 'line-height': '22px', 'font-size': '16px', color: '#2d2d2d', width: '100%' },
        color: { header: '#80864D', headerText: '#ffffff' },
        overlayOpacity: 0.5,
        dismissible: true
      }
    }
  }
}
</script>

<style>
.col-sub {
  display: block;
  font-weight: 400;
  font-size: 11px;
  opacity: 0.85;
  line-height: 1.2;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/profitReport.vue